import { React, useEffect, useState, useRef, useMemo,useCallback } from "react";
 import cogoToast from "cogo-toast"; 
import { Spinner, Row, Col, FormGroup, Label } from "reactstrap";
import { useHistory, Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Table, Button, Input } from "reactstrap";
import { AgGridReact } from "ag-grid-react";
import { genericGet, genericPost } from "../../services/Api";
import { SUCCESS_RESULT, ENDPOINTS } from "../../Constants";
import * as XLSX from "xlsx";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
 

const CycleDistributions = (props) => {
  const history = useHistory();
  const { cycle_id , cycle_name} = (props.location && props.location.state) || {};
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
 
  const gridRef = useRef();
 

  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
    };
  }, []);
  useEffect(() => {
    ListCycleDistributions();
 

    return () => { };
  }, []);

 


   
    
  // Filter list based on registration_date range
  const filteredList = useMemo(() => {
    if (!startDate && !endDate) {
      return list;
    }

    return list.filter((item) => {
      if (!item.registration_date) return false;
      
      const registrationDate = new Date(item.registration_date);
      registrationDate.setHours(0, 0, 0, 0); // Set to start of day for comparison
      
      if (startDate && endDate) {
        const start = new Date(startDate);
        start.setHours(0, 0, 0, 0);
        const end = new Date(endDate);
        end.setHours(23, 59, 59, 999); // Set to end of day for inclusive comparison
        return registrationDate >= start && registrationDate <= end;
      } else if (startDate) {
        const start = new Date(startDate);
        start.setHours(0, 0, 0, 0);
        return registrationDate >= start;
      } else if (endDate) {
        const end = new Date(endDate);
        end.setHours(23, 59, 59, 999);
        return registrationDate <= end;
      }
      
      return true;
    });
  }, [list, startDate, endDate]);

  const onBtExport = useCallback(() => {
    const dataToExport = filteredList.length > 0 ? filteredList : list;
    
    if (!dataToExport || dataToExport.length === 0) {
      cogoToast.error("No data available to export", { hideAfter: 3 });
      return;
    }

    setIsLoading(true);
    
    try {
      // Prepare Excel data with all columns
      const excelData = dataToExport.map((item, index) => ({
        "#": index + 1,
        "Name": item.name || "",
        "Age": item.age || "",
        "Gender": item.gender || "",
        "Telephone": item.telephone || "",
        "Camp": item.camp_name || "",
        "Village": item.village || "",
        "District": item.district || "",
        "Card": item.card_label || "",
        "Registration Date": item.registration_date || "",
        "Registered By": item.registered_by_name || "",
        "Redemption Date": item.redemption_date || "",
        "Redeemed By": item.redeemed_by_name || "",
        "Updated Date": item.updated_date || "",
      }));

      // Create workbook and worksheet
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(excelData);
      
      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(wb, ws, "Cycle Distributions");
      
      // Generate filename
      const fileName = `CycleDistributions_${cycle_name || 'Data'}_${new Date().toISOString().split("T")[0]}.xlsx`;
      
      // Write file
      XLSX.writeFile(wb, fileName);
      
      cogoToast.success("Data exported to Excel successfully", { hideAfter: 3 });
    } catch (error) {
      console.error("Export error:", error);
      cogoToast.error("Failed to export data. Please try again.", { hideAfter: 5 });
    } finally {
      setIsLoading(false);
    }
  }, [filteredList, list, cycle_name]);

  const clearDateFilter = () => {
    setStartDate("");
    setEndDate("");
  };

  
  const ListCycleDistributions = () => {
    setIsLoading(true);

    genericPost(ENDPOINTS.CYCLE_DISTRIBUTIONS,{
      "cycle_id": cycle_id
  })
    .then((res) => {
      setIsLoading(false);
      if (res.status == 200) {
        if (res.data.status == SUCCESS_RESULT) {
          let responseData = res.data.data;
         
          setList(responseData);
    
          }
        
        } else {
          cogoToast.error(res.data.message, {});
        }
      
    })
    .catch((err) => {
      setIsLoading(false);
      console.log(err);
    });

   
  };

  return (
    <div>
      <h1>
        CYCLE DISTRIBUTIONS [
        {startDate || endDate ? (
          <span>
            {filteredList.length} of {list.length}
          </span>
        ) : (
          list.length
        )}
        ]
      </h1>
      <Breadcrumb className="ms-1">
        <BreadcrumbItem>
          <Link to="/"> EBMS </Link>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <Link to="/"> CYCLE DISTRIBUTIONS </Link>
        </BreadcrumbItem>
        <BreadcrumbItem active>
          <Link to="/">  {cycle_name} </Link>
        </BreadcrumbItem>
      </Breadcrumb>

      <div className="d-flex justify-content-center my-1">
        {isLoading && <Spinner />}
      </div>

      <div className="card-body">
        <Row className="mb-3">
          <Col md={4}>
            <FormGroup>
              <Label>Registration Date - From</Label>
              <Input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label>Registration Date - To</Label>
              <Input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                min={startDate || undefined}
              />
            </FormGroup>
          </Col>
          <Col md={4} className="d-flex align-items-end">
            <FormGroup>
              {(startDate || endDate) && (
                <div className="mb-2">
                  <Button
                    color="secondary"
                    size="sm"
                    onClick={clearDateFilter}
                    className="mr-2"
                  >
                    Clear Filter
                  </Button>
                  <span className="text-muted" style={{ fontSize: "0.875rem" }}>
                    Showing:{" "}
                    {startDate && endDate
                      ? `${startDate} to ${endDate}`
                      : startDate
                      ? `From ${startDate}`
                      : `Up to ${endDate}`}
                  </span>
                </div>
              )}
            </FormGroup>
          </Col>
        </Row>

        <div className="mb-3">
          <a href="javascript:void(0)" onClick={onBtExport} class="btn btn-primary">
            Export To Excel
          </a>
        </div>
 


        <div className="ag-theme-alpine">
          <AgGridReact
            suppressMenuHide={true}
          
            ref={gridRef}
           
            onGridReady={(params) => {
              
            }}
            rowData={filteredList}
            domLayout={"autoHeight"}
            animateRows={true}
            pagination={true}
            paginationPageSize={100}
            defaultColDef={defaultColDef}
            resizable={true}
            enableCellTextSelection={true}
            suppressCellSelection={true}
            columnDefs={[
              {
                headerName: "#",
                filter: false,
                maxWidth: 70,
                sortable: true,
                valueFormatter: function (params) {
                  return `${parseInt(params.node.id) + 1}`;
                },
              },
              {
                headerName: "Name ",
                field: "name",
                sortable: true,
                filter: true,
              },
              {
                headerName: "Age ",
                field: "age",
                sortable: true,
                filter: true,
              }, {
                headerName: "Gender ",
                field: "gender",
                sortable: true,
                filter: true,

              },{
                headerName: "Telephone ",
                field: "telephone",
                sortable: true,
                filter: true,

              }
              // ,{
              //   headerName: "Card",
              //   field: "card_label",
              //   sortable: true,
              //   filter: true, 
              // },
              ,{
                headerName: "Camp",
                field: "camp_name",
                sortable: true,
                filter: true, 
              },
              {
                headerName: "Village",
                field: "village",
                sortable: true,
                filter: true,
              },
              {
                headerName: "District",
                field: "district",
                sortable: true,
                filter: true,
              },
              {
                headerName: "Card",
                field: "card_label",
                sortable: true,
                filter: true, 
              },
              {
                headerName: "Registration Date",
                field: "registration_date",
                sortable: true,
                filter: true,
              },
              {
                headerName: "Registered By",
                field: "registered_by_name",
                sortable: true,
                filter: true,
              },
              {
                headerName: "Redemption Date",
                field: "redemption_date",
                sortable: true,
                filter: true,
              },
              {
                headerName: "Redeemed By",
                field: "redeemed_by_name",
                sortable: true,
                filter: true,
              },
              {
                headerName: "Updated Date",
                field: "updated_date",
                sortable: true,
                filter: true,
              }
             
            ]}
          ></AgGridReact>
        </div>
      </div>
    </div>
  );
};

export default CycleDistributions;
